var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircleCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0001 2.29485C6.19233 2.29485 2.29485 6.19233 2.29485 11.0001C2.29485 15.8079 6.19233 19.7054 11.0001 19.7054C15.8079 19.7054 19.7054 15.8079 19.7054 11.0001C19.7054 6.19233 15.8079 2.29485 11.0001 2.29485ZM1.37207 11.0001C1.37207 5.6827 5.6827 1.37207 11.0001 1.37207C16.3176 1.37207 20.6282 5.6827 20.6282 11.0001C20.6282 16.3176 16.3176 20.6282 11.0001 20.6282C5.6827 20.6282 1.37207 16.3176 1.37207 11.0001Z",
    fill: "#B41730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6429 8.75944L10.0833 15.319L5.36279 10.5985L6.0153 9.946L10.0833 14.014L15.9904 8.10693L16.6429 8.75944Z",
    fill: "#B41730"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle_check.d98e5bd4d8fd94ac5815f98599531124.svg";